<!-- 维修工单管理 二级路由 -->
<template lang="pug">
    div.work-order-maintenance
        keep-alive(
            exclude='MaintenanceWorkOrderCreate,MaintenanceWorkOrderDetail'
        )
            router-view.work-order-maintenance-container
</template>
<script>
export default {
    name: 'MaintenanceWorkOrder',
    options: {
        needSavedPosition: true,
    },
};
</script>

<style lang="scss" scoped>
    .work-order-maintenance {
        height: 100%;
    }
</style>
